// src/components/FirstSteps.jsx
// What to do first, for a tournament with nothing in it yet. It stays while the first players are being added and is gone the next time the tournament is opened with players in it.
import React from 'react';
import { Link } from 'react-router-dom';

function FirstSteps() {
    return (
        <section className="card first-steps" aria-label="Getting started">
            <h2>Getting started</h2>
            <ol>
                <li>
                    <strong>Add the players</strong> below: type them in, pick them from earlier tournaments, or upload an Excel file.
                </li>
                <li>
                    <strong>Plan a round.</strong> The app pairs the players and puts them on courts.
                </li>
                <li>
                    <strong>Enter the scores</strong>, plan the next round, and watch the ranking.
                </li>
            </ol>
            <p className="hint">
                Under Settings (More on a phone) you can choose how pairings and the ranking work. More in the <Link to="/help">help</Link>.
            </p>
        </section>
    );
}

export default FirstSteps;
